import React, { ChangeEvent } from "react";
import {
    reduxForm,
    InjectedFormProps,
    ConfigProps,
    FormDecorator,
    formValueSelector,
} from "redux-form";
import blue from "material-ui/colors/blue";
import {
    Button,
    CircularProgress,
    Grid,
    FormControlLabel,
    Typography,
} from "material-ui";

import ExtendedField from "../../../components/form/ExtendedField";
import renderTextfield from "../../../components/form/RenderTextField";
import { ReduxDispatch, ReduxState } from "../../../ducks/reducers";
import { connect } from "react-redux";
import validate from "./RegisterPageFormValidator";
import { getTupasActionResponse } from "../../../ducks/tupas";
import RenderCheckBox from "../../../components/form/RenderCheckBox";
import { Link } from "react-router-dom";
import { getEIdentifyLoginData } from "ducks/eidentify";
import renderCheckBox from "../../../components/form/RenderCheckBox";
import CustomCheckboxIcon from "../../../components/Icons/CustomCheckboxIcon";
import CustomCheckboxIconChecked from "../../../components/Icons/CustomCheckboxIconChecked";
import { setAccessibilitySetting } from "util/utils";

export interface RegisterFormData {
    name: string;
    birthday: string;
    username: string | null | undefined;
    email: string;
    phoneNumber: string;
    password: string | null | undefined;
    verifyPassword: string | null | undefined;
    useTupas: boolean;
    acceptTerms: boolean;
}

const styles = {
    flex: {
        flex: 1,
    },
    menuButton: {
        marginLeft: 0,
        marginRight: -12,
    },
    inputWrapper: {
        marginBottom: 20,
    },
    RegisterForm: {
        color: "#646363",
    },
};

interface RegisterFormProps {
    form: string;
    onSubmit: (data: RegisterFormData) => void;
}

interface RegisterFormReduxProps {
    initialValues: Partial<RegisterFormData>;
    useTupas: boolean;
}
interface RegisterFormDispatchProps {}

interface RegisterFormState {}

type RegisterFormFormProps = RegisterFormProps &
    RegisterFormReduxProps &
    RegisterFormDispatchProps &
    InjectedFormProps<RegisterFormData, RegisterFormProps>;

const RegisterForm: React.SFC<RegisterFormFormProps> = (
    props: RegisterFormFormProps
) => {
    const useTupas = props.useTupas;
    return (
        <form
            style={styles.RegisterForm}
            onSubmit={props.handleSubmit(props.onSubmit)}
        >
            <Grid container>
                <Grid item xs={12} sm={6}>
                    <div style={styles.inputWrapper} className="LoginInput">
                        <ExtendedField
                            component={renderTextfield}
                            name="name"
                            type="text"
                            placeholder=""
                            adornment=""
                            label={"Nimi"}
                            disabled={true}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div style={styles.inputWrapper} className="LoginInput">
                        <ExtendedField
                            component={renderTextfield}
                            name="birthday"
                            type="text"
                            placeholder=""
                            adornment=""
                            label={"Henkilötunnus"}
                            disabled={true}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div style={styles.inputWrapper} className="LoginInput">
                        <ExtendedField
                            component={renderTextfield}
                            name="email"
                            type="email"
                            placeholder=""
                            adornment=""
                            label={"Sähköposti"}
                            required={true}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div style={styles.inputWrapper} className="LoginInput">
                        <ExtendedField
                            component={renderTextfield}
                            name="phoneNumber"
                            type="tel"
                            placeholder=""
                            adornment=""
                            label={"Puhelinnumero"}
                            required={true}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <h2 style={{ fontSize: "16px", textAlign: "center" }}>
                        Kirjautumistapa
                    </h2>
                    <Typography>
                        Luo itsellesi tunnukset, joiden avulla kirjaudut
                        mobiilipankkiin, voit myös käyttää
                        verkkopankkitunnuksiasi kirjautumiseen. Voit myöhemmin
                        vaihtaa kirjautumistavan omasta profiilistasi.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <div style={styles.inputWrapper}>
                        <FormControlLabel
                            classes={{ label: "cb-label" }}
                            control={
                                <ExtendedField
                                    component={renderCheckBox}
                                    color="primary"
                                    name="useTupas"
                                    type="checkbox"
                                    normalize={(v) => !!v}
                                />
                            }
                            label={"Kirjaudu pankkitunnuksilla"}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <h4 style={{ fontSize: "18px", color: "#646363" }}>
                        Näkemisen helpottaminen
                    </h4>
                    <Typography
                        style={{
                            marginBottom: 10,
                            color: "#646363",
                            fontSize: "14px",
                        }}
                    >
                        Sallimalla mobiililaitteen ruudun suurentamisen ja
                        kääntämisen vaaka-asentoon saat paremmin selvää
                        näytöstä.
                    </Typography>
                    <Typography style={{ color: "#646363", fontSize: "14px" }}>
                        Halutessasi voit perua asetuksen{" "}
                        <span style={{ fontStyle: "italic" }}>
                            sovelluksen käyttäjätiedot
                        </span>{" "}
                        -kohdasta.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <ExtendedField
                                component={renderCheckBox}
                                name="allowAccessibilitySettings"
                                type="checkbox"
                                onChange={handleCheckboxClick}
                                normalize={(value) => !!value}
                                className={"register checkbox"}
                                customCheckboxIcon={<CustomCheckboxIcon />}
                                customCheckboxIconChecked={
                                    <CustomCheckboxIconChecked />
                                }
                                required
                            />
                        }
                        label="Salli näytön suurentaminen ja kääntö vaaka-asentoon mobiililaitteella"
                    />
                </Grid>

                {!useTupas && (
                    <Grid item xs={12}>
                        <Grid item xs={12}>
                            <h2
                                style={{
                                    fontSize: "16px",
                                    textAlign: "center",
                                }}
                            >
                                Luo tunnukset
                            </h2>
                            <div
                                style={styles.inputWrapper}
                                className="LoginInput"
                            >
                                <ExtendedField
                                    component={renderTextfield}
                                    name="username"
                                    type="text"
                                    placeholder=""
                                    adornment=""
                                    label={"Tunnus"}
                                    required={true}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div
                                style={styles.inputWrapper}
                                className="LoginInput"
                            >
                                <ExtendedField
                                    component={renderTextfield}
                                    name="password"
                                    type="password"
                                    placeholder=""
                                    adornment=""
                                    label={"Salasana"}
                                    required={true}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div
                                style={styles.inputWrapper}
                                className="LoginInput"
                            >
                                <ExtendedField
                                    component={renderTextfield}
                                    name="verifyPassword"
                                    type="password"
                                    placeholder=""
                                    adornment=""
                                    label={"Vahvista salasana"}
                                    required={true}
                                />
                            </div>
                        </Grid>
                    </Grid>
                )}
                <Grid item xs={12}>
                    <p style={{ textAlign: "center", width: "100%" }}>
                        <Link to="/terms">Käyttöehdot</Link> ja{" "}
                        <Link to="/about">Tietoa palvelusta</Link>
                    </p>
                </Grid>
                <Grid item xs={12}>
                    <div style={styles.inputWrapper}>
                        <FormControlLabel
                            classes={{ label: "cb-label" }}
                            control={
                                <ExtendedField
                                    component={RenderCheckBox}
                                    color="primary"
                                    name="acceptTerms"
                                    type="checkbox"
                                    normalize={(v) => !!v}
                                />
                            }
                            label={"Olen lukenut ja hyväksyn käyttöehdot"}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className={"loginButton"}>
                        <Button
                            variant="raised"
                            type="submit"
                            disabled={props.submitting || props.invalid}
                        >
                            Rekisteröidy
                            {props.submitting && (
                                <CircularProgress
                                    size={24}
                                    style={{
                                        color: blue[500],
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        marginTop: -12,
                                        marginLeft: -12,
                                    }}
                                />
                            )}
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </form>
    );
};

const handleCheckboxClick = (event: ChangeEvent<HTMLInputElement>) => {
    setAccessibilitySetting(event.target.checked);
};

const form = reduxForm<RegisterFormData, RegisterFormProps>({
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(RegisterForm);

const selector = formValueSelector("register");
const mapStateToProps = (state: ReduxState): RegisterFormReduxProps => {
    let actionResponse = getEIdentifyLoginData(state);
    return {
        initialValues: {
            name: (actionResponse && actionResponse.customerName) || "",
            birthday: (actionResponse && actionResponse.customerId) || "",
        },
        useTupas: selector(state, "useTupas"),
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): RegisterFormDispatchProps => {
    return {};
};

export default connect<
    RegisterFormReduxProps,
    RegisterFormDispatchProps,
    RegisterFormProps
>(
    mapStateToProps,
    mapDispatchToProps
)(form as any);



// WEBPACK FOOTER //
// ./src/views/register/components/RegisterPageForm.tsx